namespace TabAurous.Finance {
    export interface JournalRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        SuffixPrefixId?: number;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        EnteredBy?: string;
        LedgerId?: number;
        LedgerName?: string;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        UserId?: number;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxLedgerId?: number;
        Details?: JournalDetailRow[];
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace JournalRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.Journal';
        export const deletePermission = 'Finance:Journal:Delete';
        export const insertPermission = 'Finance:Journal:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Journal:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            SuffixPrefixId = "SuffixPrefixId",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            EnteredBy = "EnteredBy",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            UserId = "UserId",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxLedgerId = "TaxLedgerId",
            Details = "Details",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
